<template>
    <div>
        <b-modal id="edit" :title="model.TransferType == 0 ? 'Şube Nakil' : model.TransferType == 1 ? 'Unvan Değişikliği' : model.TransferType == 2 ? 'Görev Yeri Değişikliği' : 'Giriş' " no-close-on-esc no-close-on-backdrop>
            <employee-organizational-edit v-model="model"></employee-organizational-edit>
            <template #modal-footer><v-executer :loading="saving" :action="transfer" :disabled="!canTransfer">{{model.TransferType == 0 ? 'Nakil Yap' : model.TransferType == 3 ? 'Giriş Yap' : 'Ata'}}</v-executer></template>
        </b-modal>

        <b-modal id="update" :title="updateModel.TransferType == 0 ? 'Şube Düzenleme' : updateModel.TransferType == 1 ? 'Unvan Düzenleme' : 'Görev Yeri Düzenleme' " no-close-on-esc no-close-on-backdrop>
            <employee-organizational-update v-model="updateModel"></employee-organizational-update>
            <template #modal-footer><v-executer :loading="updating" :action="update">Güncelle</v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="canAssign ? firstAssign : null"
                    :fields="fields"
                    pagination="server"
                    up-class="px-1 pb-1"
                    :settings="false"
                    :buttons="buttons"
                    v-on:component-action="onAction"
                    button-td-class="align-top"
                    button-alignment="text-left"
                    :hide-additional-actions="!canAssign"
                    v-on:fetch-result="assignCheck">
                    <template #empty>
                        <div class="alert alert-secondary mt-50 mb-0">
                            <div class="alert-body d-flex justify-content-between align-items-center pl-1 py-50 pr-50">
                                Personelin şube kaydı bulunmamaktadır.
                                <button v-on:click="firstAssign" class="btn btn-secondary btn-sm">Bir Şubeye Kaydet</button>
                            </div>
                        </div>
                    </template>
                </v-table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import { BButtonGroup,BButton } from 'bootstrap-vue'
import EmployeeOrganizationalEdit from './EmployeeOrganizationalEdit.vue';
import EmployeeOrganizationalUpdate from './EmployeeOrganizationalUpdate.vue';

export default {
    components:{
        BButtonGroup,
        BButton,
        EmployeeOrganizationalEdit,
        EmployeeOrganizationalUpdate
    },
    data(){
        return {
            buttons:[
                { text:"Şube Nakil",key:"changeBranch",icon:"GitBranchIcon",variant:"danger",action:this.changeBranch,condition:(i) => i.Active },
                { text:"Unvan Değişikliği",key:"changeTitle",icon:"HexagonIcon",variant:"secondary",action:this.changeTitle,condition:(i) => i.Active },
                { text:"Görev Yeri Değişikliği",key:"changeGarage",icon:"ToolIcon",variant:"warning",action:this.changeGarage,condition:(i) => i.Active },
            ],
            fields:[
                {name:'Şube',thClass:'w-26',tdClass:'p-25 align-top border-right',component:true,componentOptions:{name:"employee-department-title/EmployeeBranchDetail"}},
                {name:'Unvan',thClass:'w-37',tdClass:'p-25 align-top border-right',component:true,componentOptions:{name:"employee-department-title/EmployeeTitleDetail"}},
                {name:'Görev Yeri',thClass:'w-37',tdClass:'p-25 align-top',component:true,componentOptions:{name:"employee-department-title/EmployeeGarageDetail"}}
            ],
            model:{
                Id:null,
                TransferType:null,
                StartDate:null,
                EmployeeId:this.id,
                BranchId:null,
                BaseBranchId:null,
                TitleId:null,
                BaseTitleId:null,
                GarageId:null,
                BaseGarageId:null
            },
            updateModel:{
                Id:null,
                TransferType:null,
                StartDate:null,
                EndDate:null,
                TitleId:null,
                BranchId:null,
                GarageId:null,
            },
            saving:false,
            updating:false,
            canAssign:false
        }
    },
    props:{
        id:[String,Number],
    },
    methods:{
        clearForm(){
            this.model.TransferType = null
            this.model.StartDate = null
            this.model.BranchId = null
            this.model.BaseBranchId = null
            this.model.TitleId = null
            this.model.BaseTitleId = null
            this.model.GarageId = null
            this.model.BaseGarageId = null
        },
        firstAssign(){
            this.clearForm()
            this.model.TransferType = 3
            this.$showModal('edit')
        },
        clearUpdateModel(){
            this.updateModel.Id = null
            this.updateModel.TransferType = null
            this.updateModel.StartDate = null
            this.updateModel.EndDate = null
            this.updateModel.TitleId = null
            this.updateModel.BranchId = null
            this.updateModel.GarageId = null
        },
        provider(data){
            return EmployeeOperationsApi.DepartmentTitle.Table(data,this.id)
        },
        change(d,t){
            this.clearForm()
            this.model.TransferType = t
            this.model.BranchId = d.Branch?.Id
            this.model.BaseBranchId = d.Branch?.Id
            this.model.GarageId = d.Garages?.find(g => g.Active)?.VehicleInventoryGarage?.Id || null
            this.model.BaseGarageId = d.Garages?.find(g => g.Active)?.VehicleInventoryGarage?.Id || null
            this.model.TitleId = d.EDTs?.find(g => g.Active)?.EmployeeDepartmentTitle?.Id || null
            this.model.BaseTitleId = d.EDTs?.find(g => g.Active)?.EmployeeDepartmentTitle?.Id || null
            this.$showModal('edit')
        },
        changeBranch(d){ this.change(d,0) },
        changeTitle(d){ this.change(d,1) },
        changeGarage(d){ this.change(d,2) },
        onAction(action,row,torg){
            this.clearUpdateModel()
            if(action == 'branch-edit'){
                this.updateModel.TransferType = 0
                this.updateModel.Id = row?.Id || null
                this.updateModel.StartDate = row?.BranchStartDate || null
                this.updateModel.EndDate = row?.BranchEndDate || null
                this.$showModal('update')
            }else if (action == 'title-edit'){
                this.updateModel.TransferType = 1
                this.updateModel.Id = torg.Id || null
                this.updateModel.BranchId = row?.Branch?.Id || null
                this.updateModel.TitleId = torg?.EmployeeDepartmentTitle?.Id || null
                this.updateModel.StartDate = torg?.TitleStartDate || null
                this.updateModel.EndDate = torg?.TitleEndDate || null
                this.$showModal('update')
            }else if (action == 'garage-edit'){
                this.updateModel.TransferType = 2
                this.updateModel.Id = torg.Id || null
                this.updateModel.BranchId = row?.Branch?.Id || null
                this.updateModel.GarageId = torg?.VehicleInventoryGarage?.Id || null
                this.updateModel.StartDate = torg?.GarageStartDate || null
                this.updateModel.EndDate = torg?.GarageEndDate || null
                this.$showModal('update')
            }else if(action == 'branch-delete'){
                this.updateModel.TransferType = 0
                this.updateModel.Id = row?.Id || null
                this.delete()
            }else if(action == 'title-delete'){
                this.updateModel.TransferType = 1
                this.updateModel.Id = torg.Id || null
                this.delete()
            }else if(action == 'garage-delete'){
                this.updateModel.TransferType = 2
                this.updateModel.Id = torg.Id || null
                this.delete()
            }
        },
        transfer(){
            this.saving = true
            EmployeeOperationsApi.Operation.Transfer(this.model).then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('edit')
                }
                this.$result(res)
                this.saving = false
            }).catch(err => {
                this.$result(null,err)
                this.saving = false
            })
        },
        update(){
            let data = {}
            let api = null
            if(this.updateModel.TransferType == 0){
                data = {
                    Id: this.updateModel.Id,
                    StartDate: this.updateModel.StartDate,
                    EndDate: this.updateModel.EndDate
                }
                api = EmployeeOperationsApi.Operation.UpdateBranchSession
            }else if(this.updateModel.TransferType == 1){
                data = {
                    Id: this.updateModel.Id,
                    EDTId: this.updateModel.TitleId,
                    StartDate: this.updateModel.StartDate,
                    EndDate: this.updateModel.EndDate
                }
                api = EmployeeOperationsApi.Operation.UpdateTitle
            }else if(this.updateModel.TransferType == 2){
                data = {
                    Id: this.updateModel.Id,
                    GarageId: this.updateModel.GarageId,
                    StartDate: this.updateModel.StartDate,
                    EndDate: this.updateModel.EndDate
                }
                api = EmployeeOperationsApi.Operation.UpdateGarage
            }
            if(api){
                this.updating = true
                api(data).then(res => {
                    if(res.data.Success){
                        this.$refs.table.refresh()
                        this.$hideModal('update')
                    }
                    this.updating = false
                    this.$result(res)
                }).catch(err => {
                    this.$result(null,err)
                    this.updating = false
                })
            }
        },
        delete(){
            let api = null
            let text = ''
            if(this.updateModel.TransferType == 0) {
                api = EmployeeOperationsApi.Operation.DeleteBranchSession
                text = 'Bu işlem şube girişini siler ve geri alınamaz.'
            }
            else if(this.updateModel.TransferType == 1) {
                api = EmployeeOperationsApi.Operation.DeleteTitle
                text = 'Bu işlem unvan atamasını siler ve geri alınamaz. Bu işlemden sonra bir önceki unvan ataması aktif hale getirilir.'
            }
            else if(this.updateModel.TransferType == 2) {
                api = EmployeeOperationsApi.Operation.DeleteGarage
                text = 'Bu işlem görev yeri atamasını siler ve geri alınamaz.'
            }
            if(api && this.updateModel.Id != null){
                this.$confirm('Silmek istidiğinize emin misiniz?',text).then(c => {
                    if(c){
                        this.$refs.table.setLoading(true)
                        api(this.updateModel.Id).then(res => {
                            if(res.data.Success){
                                this.$refs.table.refresh()
                            }
                            this.$refs.table.setLoading(false)
                            this.$result(res)
                        }).catch(err => {
                            this.$result(null,err)
                            this.$refs.table.setLoading(false)
                        })
                    }
                })
            }
        },
        assignCheck(res){
        if(res.Data){
            this.canAssign = (res.Data || []).length > 0 && res.Data.every(d => d.BranchEndDate != null && d.EDTs.every(e => e.TitleEndDate != null) && d.Garages.every(g => g.GarageEndDate != null ))
            
            const activeEDT = res.Data[0]?.EDTs?.find(e => e.Active)
            if(activeEDT?.EmployeeDepartmentTitle?.CollarStatus) {
                this.$emit('collar-status-updated', activeEDT.EmployeeDepartmentTitle.CollarStatus)
            }
        }else this.canAssign = false
    }
    },
    computed:{
        canTransfer(){
            if(this.model.TransferType == 0){
                return this.model.BranchId != null && this.model.BranchId != this.model.BaseBranchId && this.model.TitleId != null && this.model.TitleId != this.model.BaseTitleId
            }else if(this.model.TransferType == 1){
                return this.model.TitleId != null && this.model.TitleId != this.model.BaseTitleId
            }else if(this.model.TransferType == 2){
                return this.model.GarageId != this.model.BaseGarageId 
            }else if (this.model.TransferType == 3){
                return this.model.BranchId != null && this.model.TitleId != null
            }
        },
        
    }
}
</script>